module.exports = __webpack_public_path__ + "images/f26125992557b78d1f437c79a8697ff54e4ab972b3fa81dd457140ee609f3cea.svg";